var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2398_739)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.411765,
    y: 0.411765,
    width: 13.1765,
    height: 13.1765,
    rx: 1.72941,
    stroke: "currentColor",
    strokeWidth: 0.823529
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.62767 0.0435829C0.983203 0.181649 0.397873 0.669529 0.152675 1.27302C-0.00738112 1.66687 5.82517e-05 1.38803 5.82517e-05 6.99991C5.82517e-05 12.6254 -0.00770933 12.3401 0.156148 12.7298C0.360895 13.2166 0.785294 13.6407 1.27334 13.8461C1.6612 14.0094 1.37837 14.0017 7.00182 14.0017C12.5617 14.0017 12.3275 14.0074 12.7014 13.8611C13.1716 13.6771 13.6134 13.2509 13.8281 12.7741C14.0012 12.3897 13.9877 12.8426 13.9968 7.09564C14.0043 2.3959 14.0008 1.84984 13.9614 1.65429C13.7982 0.84326 13.1671 0.209081 12.3567 0.0416683C12.1682 0.00274838 11.6022 -0.00160037 6.98245 0.000396229C2.50513 0.00231077 1.79347 0.0080544 1.62767 0.0435829ZM4.95052 3.71784V4.53836H4.13H3.30948V3.71784V2.89732H4.13H4.95052V3.71784ZM4.95052 8.23069V11.1025H4.13H3.30948V8.23069V5.35887H4.13H4.95052V8.23069ZM7.41208 5.5125C7.41208 5.64606 7.41834 5.66422 7.45994 5.65169C7.48625 5.64378 7.64934 5.58744 7.82234 5.52651C8.20215 5.39273 8.4741 5.34695 8.76593 5.36765C9.61268 5.42772 10.3426 6.05161 10.6174 6.95027C10.678 7.14823 10.6787 7.17113 10.6876 9.12642L10.6965 11.1025H9.87557H9.05467L9.04704 9.3589L9.03944 7.6153L8.96313 7.45989C8.81905 7.1665 8.56996 7.01471 8.23259 7.01471C7.89522 7.01471 7.64614 7.1665 7.50206 7.45989L7.42575 7.6153L7.41815 9.3589L7.41052 11.1025H6.59079H5.77104V8.23069V5.35887H6.59156H7.41208V5.5125Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2398_739"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.c63fb8170e73c36759c9bbdaff3bdaad.svg";
export { ForwardRef as ReactComponent };